<div class="MainBorder">
	<!--Menu-->
	<div>
		<button class="btn btn-primary" (click)="onUpload()">Upload CSV</button>
	</div>

	<!--Preview Table-->
	<div>
		<h4>Preview Changes:</h4>
		<div>
			<caass-batch-attendance-csv-preview-table
				[lstAttendance]="lstImportCompare"
				[TableLoading]="TableLoading"
			></caass-batch-attendance-csv-preview-table>
		</div>
	</div>

	<!--Finish-->
	<div>
		<button class="btn btn-success" (click)="onFinish()">Update Attendance</button>
	</div>
</div>
